export const DESKTOP_PREVIEW_WIDTH = 192
export const PHONE_PREVIEW_WIDTH = 104
